module.exports = __webpack_public_path__ + "img/reset-password.f829a55c.svg";